var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 14.4583C33.3116 14.2669 33.2697 14.0784 33.2083 13.8958V13.7083C33.1082 13.4941 32.9745 13.2972 32.8125 13.125L20.3125 0.625C20.1403 0.46295 19.9434 0.329335 19.7292 0.229166H19.5417L18.875 0H6.25C4.5924 0 3.00269 0.658481 1.83058 1.83058C0.65848 3.00269 0 4.5924 0 6.25V35.4167C0 37.0743 0.65848 38.664 1.83058 39.8361C3.00269 41.0082 4.5924 41.6667 6.25 41.6667H27.0833C28.7409 41.6667 30.3306 41.0082 31.5028 39.8361C32.6749 38.664 33.3333 37.0743 33.3333 35.4167V14.5833C33.3333 14.5833 33.3333 14.5833 33.3333 14.4583ZM20.8333 7.10417L26.2292 12.5H20.8333V7.10417ZM29.1667 35.4167C29.1667 35.9692 28.9472 36.4991 28.5565 36.8898C28.1658 37.2805 27.6359 37.5 27.0833 37.5H6.25C5.69747 37.5 5.16756 37.2805 4.77686 36.8898C4.38616 36.4991 4.16667 35.9692 4.16667 35.4167V6.25C4.16667 5.69747 4.38616 5.16756 4.77686 4.77686C5.16756 4.38616 5.69747 4.16667 6.25 4.16667H16.6667V14.5833C16.6667 15.1359 16.8862 15.6658 17.2769 16.0565C17.6676 16.4472 18.1975 16.6667 18.75 16.6667H29.1667V35.4167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2a0c5c634e163736be858f5f64ee179d.svg";
export { ForwardRef as ReactComponent };